import React from "react"
import shape9 from "../../images/shape/vector-shape9.png"
import shape10 from "../../images/shape/vector-shape10.png"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Autoplay } from "swiper/modules"
import DynamicImage from "../common/DynamicImage"
import SectionTitle from "../common/SectionTitle"

const Testimonials = ({ data }) => {
  return (
    <section className="testimonials-area bg-23173a ptb-70">
      <div className="container">

        <SectionTitle data={data} />

        <Swiper
          pagination={{ clickable: true }}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
          autoplay={{
            delay: 6500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          }}
          modules={[Pagination, Autoplay]}
          className="testimonials-slides"
        >
          {data?.testimonial?.map((item, index) => {
            const imageUrl = item?.image?.url
              ? `${process.env.REACT_APP_UPLOAD_URL}${item.image.url}`
              : null;

            return (
              <SwiperSlide key={index}>
                <div className="single-testimonials-box">

                  {imageUrl && (
                    <DynamicImage image={item.image} className="shadow-sm" alt={item.name} />
                  )}

                  <p>{item.description}</p>

                  <div className="client-info">
                    <div className="title">
                      <h3>{item.designation},</h3>
                      <span>{item.name}</span>
                    </div>
                  </div>

                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

      </div>

      <div className="vector-shape9">
        <img src={shape9} alt="testimonials" />
      </div>
      <div className="vector-shape10">
        <img src={shape10} alt="testimonials" />
      </div>
    </section>
  )
}

export default Testimonials
